import {
  API_FAIL,
  API_SUCCESS,
  GET_CHARTS_DATA,
  GET_CHARTS_DATA_MESSAGE_STATUS,
  GET_CHARTS_DATA_MESSAGE_STATUS_FAIL,
  GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS,
  GET_LIST_BU_STORE_HEADER,
  GET_LIST_BU_STORE_HEADER_FAIL,
  GET_LIST_BU_STORE_HEADER_SUCCESS,
  GET_LIST_BU_TENANT_HEADER,
  GET_LIST_BU_TENANT_HEADER_FAIL,
  GET_LIST_BU_TENANT_HEADER_SUCCESS,
  GET_LIST_TENANT_HEADER,
  GET_LIST_TENANT_HEADER_SUCCESS,
  RESET_GET_LIST_BU_STORE_HEADER,
  RESET_GET_LIST_BU_TENANT_HEADER,
  RESET_SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_FAIL,
  SET_BU_STORE_HEADER_SUCCESS,
  SET_BU_TENANT_HEADER,
  SET_BU_TENANT_HEADER_FAIL,
  SET_BU_TENANT_HEADER_SUCCESS,
  SET_TENANT_CODE_HEADER,
} from "./actionTypes";

export const apiSuccess = (actionType, data) => ({
  type: API_SUCCESS,
  payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
  type: API_FAIL,
  payload: { actionType, error },
});

// charts data
export const getChartsData = periodType => ({
  type: GET_CHARTS_DATA,
  payload: periodType,
});

export const setTenantCodeHeader = tenantCodeHeader => ({
  type: SET_TENANT_CODE_HEADER,
  tenantCodeHeader,
});

export const getListTenantHeader = () => ({
  type: GET_LIST_TENANT_HEADER,
});

export const getListTenantHeaderSuccess = listTenant => ({
  type: GET_LIST_TENANT_HEADER_SUCCESS,
  listTenant,
});

export const getListTenantHeaderFail = error => ({
  type: GET_LIST_TENANT_HEADER_SUCCESS,
  error,
});
// Đơn vị
export const getListBUTenantHeader = () => ({
  type: GET_LIST_BU_TENANT_HEADER,
});

export const getListBUTenantHeaderSuccess = listBu => ({
  type: GET_LIST_BU_TENANT_HEADER_SUCCESS,
  listBu,
});

export const getListBUTenantHeaderFail = error => ({
  type: GET_LIST_BU_TENANT_HEADER_FAIL,
  error,
});
export const resetGetListBuTenantHeader = () => ({
  type: RESET_GET_LIST_BU_TENANT_HEADER,
});

export const setBUTenantHeader = (buTenantHeader, buTenantHeaderInfo) => ({
  type: SET_BU_TENANT_HEADER,
  buTenantHeader,
  buTenantHeaderInfo,
});

export const setBUTenantHeaderSuccess = listMethodSign => ({
  type: SET_BU_TENANT_HEADER_SUCCESS,
  listMethodSign,
});

export const setBUTenantHeaderFail = error => ({
  type: SET_BU_TENANT_HEADER_FAIL,
  error,
});

// Store
export const getListBUStoreHeader = parentId => ({
  type: GET_LIST_BU_STORE_HEADER,
  parentId,
});

export const getListBUStoreHeaderSuccess = listBuStore => ({
  type: GET_LIST_BU_STORE_HEADER_SUCCESS,
  listBuStore,
});

export const getListBUStoreHeaderFail = error => ({
  type: GET_LIST_BU_STORE_HEADER_FAIL,
  error,
});

export const resetGetListBUStoreHeader = error => ({
  type: RESET_GET_LIST_BU_STORE_HEADER,
  error,
});

export const setBUStoreHeader = (bUStoreHeader, shopCode) => ({
  type: SET_BU_STORE_HEADER,
  bUStoreHeader,
  shopCode,
});

export const setBUStoreHeaderSuccess = (
  listMethodSign,
  listSignInfo,
  bu_store_header,
  finalBuInfo,
  finalBuReleaseInfo,
  finalListBuCode
) => ({
  type: SET_BU_STORE_HEADER_SUCCESS,
  listMethodSign,
  listSignInfo,
  bu_store_header,
  finalBuInfo,
  finalBuReleaseInfo,
  finalListBuCode,
});

export const setBUStoreHeaderFail = error => ({
  type: SET_BU_STORE_HEADER_FAIL,
  error,
});

export const resetSetBuStoreHeader = () => ({
  type: RESET_SET_BU_STORE_HEADER,
});

export const getChartsDataMessageStatus = (tenantCode, year) => ({
  type: GET_CHARTS_DATA_MESSAGE_STATUS,
  tenantCode,
  year,
});

export const getChartsDataMessageStatusSuccess = (
  listMessageWithStatus,
  chartsMLTDiep,
  chartMLTDiepInYear,
  totalMessage
) => ({
  type: GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS,
  listMessageWithStatus,
  chartsMLTDiep,
  chartMLTDiepInYear,
  totalMessage,
});

export const getChartsDataMessageStatusFail = error => ({
  type: GET_CHARTS_DATA_MESSAGE_STATUS_FAIL,
  error,
});
